import { createAction, createSlice } from "@reduxjs/toolkit";
import { CashManagementAccount } from "../models/CashManagement";
import { UUID } from "../utils";
import listFactory from "./listFactory";

const { slicePart, selectors } = listFactory<CashManagementAccount>(
  "cashManagement"
);

const initialState = {
  ...slicePart.initialState,
  testSettlementResponse: {},
};

export const slice = createSlice({
  ...slicePart,
  initialState,
  reducers: {
    setList: slicePart.reducers.setList,
    setItem: slicePart.reducers.setItem,
    updateItem: slicePart.reducers.updateItem,
    setTestCashManagementResponse: (state, action) => {
      const { data } = action.payload;
      state.testSettlementResponse = data;
    },
  },
});

export const { setList, setItem, updateItem } = slice.actions;

export const fetchCashManagementAccounts = createAction<{
  id: UUID;
  active?: boolean | undefined;
}>("fetchCashManagementAccounts");

export const fetchCashManagementAccount = createAction<{ id: UUID }>(
  "fetchCashManagementAccount"
);
export const updateCashManagementAccount = createAction<{
  id: UUID;
  data: CashManagementAccount;
}>("updateCashManagementAccount");
export const createCashManagementAccount = createAction<{
  id: UUID;
  data: CashManagementAccount;
}>("createCashManagementAccount");

export const sendTestSettlementBatch = createAction<
  { id: UUID },
  "sendTestSettlementBatch"
>("sendTestSettlementBatch");

export const setCashManagementAccountActiveFlag = createAction<{
  id: UUID;
  data: CashManagementAccount;
}>("setCashManagementAccountActiveFlag");

export const {
  selectList: selectCashManagementAccounts,
  selectItem: selectCashManagementAccount,
} = selectors;

export const selectTestCashManagementResponse = (state: any) => {
  return state.cashManagement.testSettlementResponse;
};

export const cashManagementOperationPaths = (id?: UUID) => {
  return {
    listing: ["cashManagement", "listing", id],
    details: ["cashManagement", "details", id],
    update: ["cashManagement", "update", id],
    create: ["cashManagement", "create", id],
    setActiveFlag: ["cashManagement", "setActiveFlag", id],
    sendTestSettlementBatch: ["cashManagement", "sendSettlementBatch", id],
  };
};

export default slice.reducer;
